import React, { useEffect, useState } from 'react';
import { Droppable as OriginalDroppable } from 'react-beautiful-dnd';

/**
 * Este componente é um wrapper em torno do Droppable original do react-beautiful-dnd.
 * Ele corrige um problema de compatibilidade com o StrictMode do React 18, que causa
 * a quebra da funcionalidade de arrastar e soltar devido à dupla renderização no modo de desenvolvimento.
 * 
 * Referência: https://github.com/atlassian/react-beautiful-dnd/issues/2399#issuecomment-1175638192
 */
export const Droppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <OriginalDroppable {...props}>{children}</OriginalDroppable>;
};
